export const categories = [
  {
    slug: "star",
    name: "明星黑料",
    navLabel: "明星",
    description:
      "聚焦明星台前幕后的真实动态：片场传闻、行程异动、团队回应与当事人态度，我们只整理已被多方提及的细节。",
    keywords: "明星黑料,明星八卦,明星动态,艺人绯闻",
    tagline: "镜头之外，故事才刚开始",
  },
  {
    slug: "entertainment",
    name: "娱乐八卦",
    navLabel: "娱乐",
    description:
      "综艺、音乐、影视与演出市场的第一现场。剪辑争议、合约变动、票房与巡演内幕，一条条讲清楚。",
    keywords: "娱乐黑料,娱乐八卦,综艺内幕,音乐圈",
    tagline: "追热点，也追真相",
  },
  {
    slug: "society",
    name: "社会热点",
    navLabel: "社会",
    description:
      "从网络谣言到消费陷阱，我们关注热点事件背后的链条与普通人的处境，提供可核对的背景与时间线。",
    keywords: "社会黑料,社会热点,网络谣言,消费陷阱",
    tagline: "热点背后，还有人",
  },
];

export const articles = [
  {
    id: "lin-wanxing-live-2026",
    title: "独家｜林晚星深夜直播失言，工作室三小时后紧急回应",
    summary:
      "一场原定四十分钟的深夜直播，因为一句没说完的话冲上热搜。我们梳理了直播时间线、被剪掉的片段，以及工作室凌晨发布的完整声明。",
    category: "star",
    region: "内地",
    tags: ["直播风波", "危机公关", "明星动态"],
    author: "夜航观察员",
    publishedAt: "2026-10-17T09:12:00",
    views: 128400,
    commentCount: 862,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20young%20female%20singer%20in%20a%20black%20coat%20leaving%20a%20television%20studio%20late%20at%20night%2C%20glowing%20deep%20red%20neon%20reflections%20on%20wet%20pavement%2C%20blurred%20assistants%20and%20photographers%20in%20the%20background%2C%20moody%20dramatic%20side%20lighting%2C%20magazine%20photojournalism%20style%2C%20high%20detail%2C%20warm%20neutral%20tones&width=1200&height=750&seq=hl51-linwanxing&orientation=landscape",
    paragraphs: [
      "10 月 16 日 23 点 07 分，林晚星在个人账号开启了一场没有任何预告的直播。画面里她穿着一件黑色针织外套，背景是熟悉的排练室，镜头略有些晃。开播十分钟内在线人数就突破了二十万，弹幕几乎铺满屏幕。",
      "争议出现在直播的第 27 分钟。谈到近期关于她与某制作人合作破裂的传闻时，林晚星说了一句“有些事不是我不说，是说了有人会……”随后停顿了近五秒，直播画面被切到音乐界面。这段空白迅速被录屏传播，不同版本的解读在两小时内挤满了各个平台。",
      "17 日凌晨 1 点 40 分，林晚星工作室发布声明，称直播中提到的内容与任何合作方无关，属于个人情绪表达，并确认当晚直播提前结束是团队协商后的决定。声明的落款时间比事件发酵晚了将近三个小时，这一点也被不少网友拿来讨论。",
      "截至发稿，林晚星本人没有再更新动态。其经纪团队向我们表示，后续会以作品和正式采访回应外界关心的问题。我们也联系了传闻中涉及的制作方，对方仅回复“暂不方便回应”。",
    ],
    featured: true,
  },
  {
    id: "night-star-editing",
    title: "综艺《夜航星》剪辑风波升级，节目组被曝临时改赛制",
    summary:
      "选手镜头被大幅删减、淘汰环节顺序颠倒，观众开始逐帧对比。我们拿到了两版赛制流程表，差异比想象中更大。",
    category: "entertainment",
    region: "内地",
    tags: ["综艺", "剪辑争议", "赛制"],
    author: "综艺前哨",
    publishedAt: "2026-10-17T08:05:00",
    views: 96320,
    commentCount: 671,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20an%20empty%20television%20variety%20show%20studio%20at%20night%2C%20rows%20of%20warm%20orange%20audience%20seats%2C%20large%20LED%20screens%20glowing%20red%2C%20cameras%20and%20cables%20scattered%20on%20the%20floor%2C%20dramatic%20side%20lighting%2C%20moody%20atmosphere%2C%20magazine%20photojournalism%20style%2C%20high%20detail&width=1200&height=750&seq=hl51-variety-studio&orientation=landscape",
    paragraphs: [
      "《夜航星》第三期上线不到十二小时，相关话题就占据了热搜榜的三个位置。争议的核心并不在舞台，而在剪辑：多位选手的备采片段被压缩到只剩一句，原本完整的组队环节被拆散插播。",
      "一位参与录制的现场观众向我们描述，实际录制中有一段近二十分钟的自由讨论，播出时只剩下四十秒。“现场的气氛和成片完全不是一回事。”她说。",
      "更让观众在意的是赛制变化。我们对比了两份不同时间流出的流程表，早期版本中设有“复活票”，而最终播出时这一环节被取消，改为由导师直接决定。节目组目前尚未解释调整原因。",
      "节目宣传负责人回应称，剪辑与赛制调整都属于正常的制作流程，目的是保证节奏与观感，并强调不存在针对任何选手的情况。至于是否会公开完整版素材，对方表示“需要内部评估”。",
    ],
    featured: true,
  },
  {
    id: "platform-rumor-chain",
    title: "某短视频平台“爆料号”被约谈，造谣产业链浮出水面",
    summary:
      "从素材采购、批量剪辑到账号矩阵分发，一条完整的爆料流水线被拆开。有人月入六位数，也有人因一条假消息被追责。",
    category: "society",
    region: "内地",
    tags: ["平台治理", "网络谣言", "调查"],
    author: "社会观察组",
    publishedAt: "2026-10-16T21:40:00",
    views: 88750,
    commentCount: 534,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20dark%20desk%20covered%20with%20several%20smartphones%20showing%20blurred%20social%20media%20feeds%2C%20a%20notebook%20with%20handwritten%20notes%20beside%20them%2C%20warm%20orange%20desk%20lamp%20light%20cutting%20through%20the%20shadows%2C%20investigative%20journalism%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1200&height=750&seq=hl51-platform-probe&orientation=landscape",
    paragraphs: [
      "本周，多个以“内部爆料”为标签的短视频账号陆续停止更新。平台方面确认，已就部分账号发布不实信息的问题进行约谈，并启动内容复核。",
      "根据我们接触到的两名前运营人员描述，这类账号通常由三到五人组成：一人负责在社交平台搜罗未经证实的聊天记录与截图，一人负责配音和剪辑，其余人管理十几个分发账号。“一条能爆的内容，两个小时就能铺满全网。”其中一人说。",
      "素材的来源往往并不复杂。有人专门在粉丝群、二手交易群收购“内部消息”，价格从几十元到上千元不等；也有人直接把旧闻改个时间重新发布。真正被核实的比例，远低于观众的想象。",
      "法律界人士提醒，转发量达到一定标准后，发布者与部分传播者都可能承担相应责任。平台此次复核会持续多久、是否会公开处理结果，目前仍没有明确时间表。",
    ],
    featured: true,
  },
  {
    id: "gu-qingye-standin",
    title: "顾清野新剧片场路透流出，替身争议再被翻出",
    summary:
      "一段十七秒的片场视频让“到底谁在演”成了讨论焦点。剧组工作人员的说法，与粉丝看到的画面并不一致。",
    category: "star",
    region: "内地",
    tags: ["片场", "替身争议", "影视"],
    author: "片场记录员",
    publishedAt: "2026-10-16T18:20:00",
    views: 74210,
    commentCount: 418,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20historical%20film%20set%20at%20dusk%2C%20wooden%20scaffolding%20and%20vintage%20camera%20equipment%2C%20crew%20silhouettes%20in%20the%20background%2C%20deep%20red%20sky%20and%20warm%20dust%20haze%2C%20dramatic%20side%20lighting%2C%20magazine%20photojournalism%20style%2C%20high%20detail&width=1200&height=750&seq=hl51-filmset-dusk&orientation=landscape",
    paragraphs: [
      "视频是在横店一处外景地拍到的。画面中，一个身穿戏服的身影从马背上翻落，动作干净利落，随后镜头迅速被遮挡。发布者称拍摄时间是 10 月 14 日下午。",
      "争议点在于，这个镜头此前被宣传为顾清野的“亲自上阵”。粉丝整理了官方发布的训练花絮，认为动作节奏与身形都吻合；但也有网友指出，视频中的侧脸与演员本人存在差异。",
      "一位剧组工作人员向我们表示，高难度动作使用专业替身是行业常规，演员本人完成了其余大部分镜头。“危险动作有保险和工时限制，不是愿不愿意的问题。”他说。",
      "顾清野方面暂未回应。制片方则回复称，所有宣传物料均经过演员团队确认，不存在夸大表述，后续会考虑公开部分拍摄花絮。",
    ],
    featured: false,
  },
  {
    id: "su-nian-agency",
    title: "苏念与经纪公司合约到期不续，独立工作室已注册",
    summary:
      "合作七年的双方选择在秋天分开。工商信息显示，新工作室的注册地址就在她常去的那栋写字楼。",
    category: "star",
    region: "港台",
    tags: ["合约", "经纪公司", "独立发展"],
    author: "港台线人",
    publishedAt: "2026-10-16T14:05:00",
    views: 68300,
    commentCount: 392,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20quiet%20entertainment%20agency%20office%2C%20a%20stack%20of%20contract%20papers%20and%20a%20pen%20on%20a%20wooden%20desk%2C%20warm%20afternoon%20light%20through%20window%20blinds%2C%20blurred%20empty%20chair%2C%20deep%20red%20accent%20folder%2C%20editorial%20business%20photography%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=hl51-agency-office&orientation=landscape",
    paragraphs: [
      "多方信息显示，苏念与现经纪公司的合约已于本月初到期，双方决定不再续约。消息传出后，公司官网的艺人页面在半天内做了调整。",
      "我们查询工商登记信息发现，一家以苏念英文名缩写命名的工作室已于 9 月底完成注册，经营范围包含演出经纪、影视制作与版权代理。注册地址位于她过去两年常被拍到出入的写字楼。",
      "接近双方的人士称，这次分开属和平协商，此前的影视与代言合约仍会由原公司协助执行到约满。“不是撕破脸，是节奏不一样了。”该人士说。",
      "截至发稿，苏念在社交平台发布了一张秋天的街景照片，没有配文。评论区最高赞的一条写着“新的开始”。",
    ],
    featured: false,
  },
  {
    id: "concert-scalper-chain",
    title: "演唱会黄牛票源头调查：三层代理如何把票价抬高四倍",
    summary:
      "从“内部票”到“代抢服务”，我们跟着一位购票者走完了整条链路。加价的每一环，都有人抽成。",
    category: "society",
    region: "内地",
    tags: ["演出市场", "黄牛", "消费维权"],
    author: "消费调查组",
    publishedAt: "2026-10-16T10:30:00",
    views: 61200,
    commentCount: 356,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20huge%20concert%20crowd%20outside%20a%20stadium%20at%20night%2C%20glowing%20orange%20lights%20and%20phone%20screens%2C%20security%20fences%20in%20foreground%2C%20deep%20red%20stage%20glow%20in%20the%20distance%2C%20dramatic%20atmosphere%2C%20magazine%20photojournalism%20style%2C%20high%20detail&width=1200&height=750&seq=hl51-concert-crowd&orientation=landscape",
    paragraphs: [
      "开票三十秒售罄，二手平台立刻出现大量“现票”。这不是新鲜事，但价格究竟是怎么被抬上去的，很少有人讲清楚。",
      "我们以购票者身份联系了三名卖家。第一层是社交平台上的个人代理，报价为原价的 2.2 倍；第二层自称“有内部渠道”，报价 3 倍并要求先付定金；第三层则直接给出整排座位，价格是原价的 4 倍，但拒绝说明票源。",
      "一位曾做过代抢的从业者透露，所谓内部票中有相当一部分来自批量账号抢购与“代拍团队”，真正从主办方流出的比例并不高。“加价的钱，一半在代理手里，一半要用来覆盖抢票成本和退票风险。”",
      "演出行业协会近期再次提醒，非官方渠道购票存在无法入场、无法退改的风险。多位受访者也表示，希望平台在开票环节加强实名与限购校验，而不是只在事后清理信息。",
    ],
    featured: false,
  },
  {
    id: "ye-zhiqiu-apartment",
    title: "叶知秋被拍到与神秘友人同回公寓，团队回应“只是朋友”",
    summary:
      "深夜的街拍只有九张图，却足够让讨论持续一整晚。团队在凌晨给出回应，措辞相当简短。",
    category: "star",
    region: "港台",
    tags: ["街拍", "恋情传闻", "回应"],
    author: "港台线人",
    publishedAt: "2026-10-15T22:15:00",
    views: 58900,
    commentCount: 301,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20quiet%20residential%20alley%20in%20a%20city%20at%20night%2C%20a%20figure%20in%20a%20hooded%20coat%20walking%20away%20under%20warm%20street%20lamps%2C%20deep%20red%20reflections%20on%20wet%20asphalt%2C%20blurred%20apartment%20windows%2C%20mysterious%20mood%2C%20editorial%20photojournalism%2C%20high%20detail&width=1200&height=750&seq=hl51-night-alley&orientation=landscape",
    paragraphs: [
      "照片拍摄于 10 月 14 日晚间，地点是港岛一处住宅区。叶知秋与一名同行者先后下车，保持着一段距离走进楼内，全程没有明显互动。",
      "图片发布后，讨论很快分成两派：有人认为只是工作人员同行，也有人翻出两人此前的同款配件作为“证据”。需要注意的时，这些所谓的同款并没有明确的购买时间。",
      "15 日凌晨，叶知秋团队向媒体回应：“只是朋友，当天是朋友聚会结束顺路。”回应中没有提及同行者身份，也未对拍摄方式作出评价。",
      "值得一提的是，近半年港台媒体对艺人私生活的拍摄尺度屡次引发讨论。有律师指出，在住宅出入口长期蹲守拍摄，可能触及隐私边界。",
    ],
    featured: false,
  },
  {
    id: "music-festival-lineup",
    title: "音乐节阵容临时换人，主办方深夜发长文致歉",
    summary:
      "开场前十八小时，压轴嘉宾换人。退票方案、交通补偿和舞台调整，主办方一次说清了吗？",
    category: "entertainment",
    region: "内地",
    tags: ["音乐节", "演出", "致歉"],
    author: "现场编辑部",
    publishedAt: "2026-10-15T16:40:00",
    views: 52400,
    commentCount: 288,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20music%20festival%20stage%20at%20night%20before%20the%20show%2C%20empty%20microphone%20stand%2C%20orange%20and%20red%20beams%20cutting%20through%20fog%2C%20crowd%20silhouettes%20far%20in%20the%20background%2C%20dramatic%20concert%20lighting%2C%20magazine%20photojournalism%2C%20high%20detail&width=1200&height=750&seq=hl51-festival-stage&orientation=landscape",
    paragraphs: [
      "原定本周末举行的城市音乐节，在开场前一天宣布压轴嘉宾因“不可抗力”缺席，由另一组音乐人顶替。消息发布时，已有大量观众抵达当地。",
      "主办方在深夜发出的长文中给出两个方案：保留门票者可获得部分周边补偿，选择退票者可在七个工作日内申请全额退款。文中也承认，交通与住宿损失暂时无法覆盖。",
      "多位观众对此并不买账。“机票和酒店都订好了，退票解决不了问题。”一位从外地赶来的观众说。也有观众认为，临时换人在大型演出中并非罕见，关键在沟通是否及时。",
      "截至发稿，音乐节方面表示舞台流程已完成调整，演出将按计划进行。当地文旅部门称已介入了解情况，要求主办方做好现场服务与退改说明。",
    ],
    featured: false,
  },
  {
    id: "restaurant-queue-business",
    title: "网红餐厅“排队神话”背后：雇人排队的灰色生意",
    summary:
      "三小时起步的队伍，有多少是真实食客？我们找到了两位曾参与排队的人，他们按小时结算。",
    category: "society",
    region: "内地",
    tags: ["餐饮", "营销乱象", "暗访"],
    author: "城市暗访组",
    publishedAt: "2026-10-15T09:25:00",
    views: 49800,
    commentCount: 240,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20trendy%20restaurant%20entrance%20with%20empty%20queue%20barriers%2C%20warm%20orange%20sign%20light%20on%20a%20pale%20wall%2C%20a%20hostess%20podium%20and%20menus%2C%20blurred%20pedestrians%20passing%20by%2C%20urban%20evening%20mood%2C%20editorial%20food%20business%20photography%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=hl51-restaurant-queue&orientation=landscape",
    paragraphs: [
      "这家开业不到两个月的餐厅，工作日中午也要排队两个半小时。社交平台上的视频里，队伍从门口一直绕到街角，成了“必须打卡”的证据。",
      "但我们连续三天的观察发现了规律：每天上午十点半和下午四点，总会有几组人在固定位置集合，彼此并不交谈，却轮流进入队列。有人手里拿着统一的小票。",
      "两位参与者向我们确认，他们是通过兼职群接单的“占位人员”，按小时结算，每单 35 到 50 元不等。任务要求很简单：排到指定位置，等群里通知再离开。",
      "餐厅方面回应称，从未组织或委托任何人排队，怀疑是第三方营销公司所为，并表示会配合调查。市场监管部门提醒，若查实存在虚假宣传，商家可能面临相应处罚。",
    ],
    featured: false,
  },
  {
    id: "sato-rin-romance",
    title: "佐藤凛事务所承认恋情？日媒爆料时间线全梳理",
    summary:
      "从同框照到事务所措辞的变化，这条新闻的关键不在“承认”两个字，而在三次不同版本的回应。",
    category: "star",
    region: "日韩",
    tags: ["日娱", "恋情", "事务所回应"],
    author: "东亚娱乐观察",
    publishedAt: "2026-10-14T20:10:00",
    views: 45600,
    commentCount: 219,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20photograph%20of%20a%20young%20Japanese%20actress%20in%20a%20beige%20trench%20coat%20standing%20on%20a%20Tokyo%20street%20at%20night%2C%20soft%20warm%20street%20lamp%20light%2C%20blurred%20neon%20signs%20behind%20her%2C%20deep%20red%20umbrella%20accent%2C%20dramatic%20shallow%20depth%20of%20field%2C%20magazine%20photojournalism%20style&width=1200&height=750&seq=hl51-sato-rin&orientation=landscape",
    paragraphs: [
      "日本某周刊在最新一期中刊登了佐藤凛与一名舞台剧演员连续两晚同行的照片。报道称，两人曾在同一部作品中合作，此后保持联系。",
      "真正引起讨论的是事务所的回应。第一次，事务所称“私事交由本人处理”；第二次改为“两人是关系很好的前辈后辈”；第三次则在官网简短表示“不否认媒体报道的内容”。",
      "熟悉日娱公关流程的记者分析，这类措辞递进通常意味着团队内部对公开程度存在分歧。“不是承认，也不是否认，更像是在观察舆论反应。”",
      "佐藤凛目前正在拍摄新剧，剧组方面表示拍摄计划不受影响。至于粉丝最关心的“是否会影响作品宣传”，目前尚无官方安排。",
    ],
    featured: false,
  },
  {
    id: "elena-ross-tour",
    title: "Elena Ross 巡演取消内幕，主办方亏损细节曝光",
    summary:
      "一场售罄的巡演为什么突然停下？舞台运输、汇率和保险，三个数字解释了大部分问题。",
    category: "entertainment",
    region: "欧美",
    tags: ["欧美音乐", "巡演", "商业内幕"],
    author: "海外文化组",
    publishedAt: "2026-10-14T15:35:00",
    views: 41200,
    commentCount: 187,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20an%20empty%20European%20concert%20hall%20stage%20with%20a%20grand%20piano%2C%20warm%20amber%20spotlights%20and%20deep%20red%20curtains%2C%20scattered%20sheet%20music%20on%20the%20floor%2C%20dramatic%20shadows%2C%20magazine%20photojournalism%20style%2C%20high%20detail&width=1200&height=750&seq=hl51-elena-hall&orientation=landscape",
    paragraphs: [
      "Elena Ross 的亚洲巡演在开演前两周宣布取消，涉及四个城市。官方给出的理由是“制作周期与场地条件无法匹配”，但行业内的讨论显然更复杂。",
      "一位参与项目前期筹备的商务人士向我们提供了部分预算表：舞台设备需要从欧洲海运，运输成本较去年上涨约三成；同时，多个场馆的档期在夏季被大型体育赛事挤占，只能压缩装台时间。",
      "更关键的是保险。由于连续取消的演出案例增加，承保方对大型巡演的要求变得更严格，保费上涨直接压缩了利润空间。“票房看起来很好，但成本结构已经变了。”该人士说。",
      "主办方在最新声明中承诺，所有购票观众将在十五个工作日内收到全额退款，并保留未来场次的优先购票权。Elena Ross 本人尚未公开发声。",
    ],
    featured: false,
  },
  {
    id: "zhou-muye-crew",
    title: "周牧野团队否认“耍大牌”，剧组工作人员发声",
    summary:
      "一条匿名爆料帖，把剧组日常推到了聚光灯下。我们联系到三位工作人员，他们给出了不同版本。",
    category: "star",
    region: "内地",
    tags: ["剧组", "工作风波", "回应"],
    author: "片场记录员",
    publishedAt: "2026-10-14T11:00:00",
    views: 38900,
    commentCount: 164,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20film%20crew%20backstage%20in%20a%20dim%20corridor%2C%20lighting%20stands%20and%20folded%20chairs%2C%20a%20call%20sheet%20taped%20to%20the%20wall%2C%20warm%20orange%20practical%20lights%2C%20deep%20red%20curtain%20edge%2C%20documentary%20style%2C%20shallow%20depth%20of%20field&width=1200&height=750&seq=hl51-crew-backstage&orientation=landscape",
    paragraphs: [
      "爆料帖称，周牧野在拍摄期间多次要求调整通告时间，导致夜戏连续推迟。帖子没有配图，发布者自称是剧组临时工作人员。",
      "我们联系到三位剧组人员。一位场记表示，确实有过两次因演员身体原因调整拍摄顺序的情况；另一位灯光师则说，整体进度正常，“没有到影响其他人的程度”。第三位工作人员拒绝评价，只说“合同里写了不能对外说”。",
      "周牧野团队回应称，相关说法严重失实，所有行程调整均经制片部门同意，并已保留证据。制片方也发声明，称剧组运转正常，呼吁外界不要传播未经核实的信息。",
      "事件发展到这里，最有意思的其实是信息传播方式：一张聊天记录截图，可以在几小时内变成“行业共识”。这也是我们持续做核实报道的原因。",
    ],
    featured: false,
  },
  {
    id: "shen-yizhou-plagiarism",
    title: "沈亦舟新专辑被指“撞旋律”，制作方发声明",
    summary:
      "两段副歌被网友做成对比音频。音乐人、制作方和平台，各自给出了不同层面的解释。",
    category: "entertainment",
    region: "港台",
    tags: ["音乐", "版权", "声明"],
    author: "听觉研究所",
    publishedAt: "2026-10-13T19:45:00",
    views: 35600,
    commentCount: 143,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20modern%20recording%20studio%20at%20night%2C%20mixing%20console%20with%20glowing%20faders%2C%20a%20microphone%20in%20a%20booth%20behind%20glass%2C%20warm%20orange%20and%20deep%20red%20ambient%20light%2C%20empty%20producer%20chair%2C%20editorial%20music%20journalism%2C%20high%20detail&width=1200&height=750&seq=hl51-recording-studio&orientation=landscape",
    paragraphs: [
      "争议起于一条对比视频。博主把沈亦舟新专辑同名主打的副歌，与两年前一首独立作品放在一起播放，认为和声走向与节奏型“高度相似”。视频播放量在一天内突破三百万。",
      "我们咨询了两位编曲从业者。他们表示，两段旋律确实存在相似动机，但判断是否构成侵权需要比对完整的乐谱与音轨，“单靠十几秒的听感，很难下结论”。",
      "沈亦舟的制作方在声明中称，作品为独立创作，已完成版权登记，并愿意配合任何专业机构的鉴定。声明同时提到，网络上的对比视频存在剪辑加速的情况。",
      "平台方面已对部分原视频加上“内容存在争议”的提示。截至发稿，独立音乐人一方尚未公开回应。",
    ],
    featured: false,
  },
  {
    id: "campus-substitute-scam",
    title: "高校“代课代考”暗访：一条帖子背后的灰色链条",
    summary:
      "在校园群里发一条模糊的招募信息，就能组起一个小型服务网络。价格、风险与监管，都藏在聊天记录里。",
    category: "society",
    region: "内地",
    tags: ["校园", "灰色产业", "暗访"],
    author: "城市暗访组",
    publishedAt: "2026-10-13T10:20:00",
    views: 32100,
    commentCount: 128,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20quiet%20university%20corridor%20in%20the%20afternoon%2C%20rows%20of%20closed%20classroom%20doors%2C%20sunlight%20and%20long%20shadows%20on%20the%20floor%2C%20a%20notice%20board%20with%20blurred%20flyers%2C%20deep%20red%20banner%20accent%2C%20documentary%20editorial%20style%2C%20high%20detail&width=1200&height=750&seq=hl51-campus-corridor&orientation=landscape",
    paragraphs: [
      "“帮点到，一次三十，长期可谈。”这类信息通常不会出现在公开平台，而是藏在校园二手群、拼单群的文件名里。我们用了两周时间，接触了其中三个发布者。",
      "他们的运作方式出奇一致：接单、核对课程信息、安排人员、课后结算。有的还提供“包月套餐”，价格从一百多到四百不等。对方强调“绝对安全”，但当被问及被发现怎么办时，只回了一句“自己承担”。",
      "一所高校的辅导员告诉我们，代课现象在线上授课时期明显增加，学校已通过随机点名、课堂互动等方式加强管理，但取证依然困难。“学生之间会互相提醒，很难查到具体的人。”",
      "教育学者建议，除了纪律处分，更应关注课程本身的价值感。“如果一门课只剩下签到，学生自然会寻找最省力的方式。”这或许比追查单个账号更值得讨论。",
    ],
    featured: false,
  },
  {
    id: "bai-lu-variety-cut",
    title: "白露综艺镜头被删减，粉丝要求节目组公开剪辑标准",
    summary:
      "从第一期的主咖到第三期的背景板，镜头数量的变化引来了另一种质疑：综艺到底有没有“隐形排名”？",
    category: "star",
    region: "内地",
    tags: ["综艺", "镜头分配", "粉丝争议"],
    author: "综艺前哨",
    publishedAt: "2026-10-12T21:30:00",
    views: 29800,
    commentCount: 112,
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photograph%20of%20a%20bright%20variety%20show%20stage%20with%20tiered%20seating%20and%20colorful%20warm%20lighting%2C%20empty%20contestant%20podium%2C%20orange%20spotlights%2C%20camera%20tracks%20in%20the%20foreground%2C%20deep%20red%20backdrop%2C%20magazine%20photojournalism%20style%2C%20high%20detail&width=1200&height=750&seq=hl51-variety-stage&orientation=landscape",
    paragraphs: [
      "粉丝的统计表做得相当细致：第一期白露单人镜头 6 分 42 秒，第二期 3 分 18 秒，第三期不足 1 分钟。表格发布后，“镜头去哪了”成了讨论话题。",
      "节目组内部人士表示，镜头分配主要取决于当期游戏环节与嘉宾互动效果，并不存在预设排名。“有些素材现场很好笑，剪进去却不好笑，这是常有的事。”",
      "但也有观众指出，第三期中白露参与的完整段落被放在会员加更版，正片只保留了一个反应镜头。这样的编排是否合理，恐怕很难有统一答案。",
      "白露方面暂未回应。她的后援会发布声明，希望节目组公开剪辑原则，并呼吁粉丝理性表达。节目组表示会在下一期片尾增加幕后片段。",
    ],
    featured: false,
  },
];

export const hotComments = [
  {
    id: "c1",
    user: "吃瓜不站队",
    text: "凌晨三点的声明看了三遍，重点其实是那五秒空白吧。",
    time: "12 分钟前",
    articleId: "lin-wanxing-live-2026",
  },
  {
    id: "c2",
    user: "剪辑室观察",
    text: "两版流程表一对比就明白了，复活票没了才是核心争议。",
    time: "28 分钟前",
    articleId: "night-star-editing",
  },
  {
    id: "c3",
    user: "白噪音",
    text: "黄牛那段太真实了，去年我就被第二层代理坑过定金。",
    time: "41 分钟前",
    articleId: "concert-scalper-chain",
  },
  {
    id: "c4",
    user: "夜航船",
    text: "替身是行业常规，宣传时别写“亲自上阵”就行。",
    time: "1 小时前",
    articleId: "gu-qingye-standin",
  },
  {
    id: "c5",
    user: "南方以南",
    text: "代课这条线值得深挖，问题不在学生一个人身上。",
    time: "2 小时前",
    articleId: "campus-substitute-scam",
  },
  {
    id: "c6",
    user: "半糖去冰",
    text: "排队那家我也去过，难怪总觉得队伍里没人说话。",
    time: "2 小时前",
    articleId: "restaurant-queue-business",
  },
  {
    id: "c7",
    user: "唱片机",
    text: "希望能看到一个专业机构的鉴定结果，别只靠剪辑对比。",
    time: "3 小时前",
    articleId: "shen-yizhou-plagiarism",
  },
  {
    id: "c8",
    user: "港岛的风",
    text: "回应三次三个说法，这本身就很值得玩味。",
    time: "3 小时前",
    articleId: "sato-rin-romance",
  },
];

export const popularKeywords = [
  "明星行程",
  "综艺剪辑",
  "演唱会",
  "平台治理",
  "经纪合约",
  "片场",
  "音乐版权",
  "校园灰色产业",
];

export const teamMembers = [
  {
    name: "陆知远",
    role: "主编 / 内容统筹",
    bio: "做过八年娱乐记者，习惯先看时间线，再下判断。负责本站选题方向与事实核对流程。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photograph%20of%20a%20calm%20Chinese%20man%20in%20his%20late%20thirties%20wearing%20a%20dark%20knit%20sweater%2C%20seated%20in%20a%20warm%20dim%20office%2C%20soft%20window%20light%20on%20his%20face%2C%20deep%20red%20background%20accent%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20professional%20magazine%20photography&width=400&height=400&seq=hl51-team-lu&orientation=squarish",
  },
  {
    name: "程一诺",
    role: "娱乐线记者",
    bio: "常驻剧组与演出现场，关注综艺制作流程、合约变动与幕后工种的真实处境。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photograph%20of%20a%20young%20Chinese%20woman%20with%20short%20hair%20wearing%20a%20beige%20blazer%2C%20standing%20in%20a%20bright%20studio%20corridor%2C%20warm%20orange%20side%20lighting%2C%20confident%20expression%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20professional%20magazine%20photography&width=400&height=400&seq=hl51-team-cheng&orientation=squarish",
  },
  {
    name: "许砚",
    role: "社会调查组",
    bio: "做消费与平台治理方向的核实报道，相信每一条爆料背后都应该有可查证的细节。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photograph%20of%20a%20thoughtful%20Chinese%20man%20in%20his%20forties%20with%20glasses%20and%20a%20grey%20shirt%2C%20sitting%20at%20a%20wooden%20desk%20with%20notebooks%2C%20warm%20lamp%20light%2C%20muted%20red%20wall%20behind%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=400&height=400&seq=hl51-team-xu&orientation=squarish",
  },
  {
    name: "南栀",
    role: "视觉与数据编辑",
    bio: "负责图表、时间线与图片呈现，让复杂的爆料信息在一屏之内被读懂。",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20photograph%20of%20a%20young%20Chinese%20woman%20with%20long%20dark%20hair%20in%20a%20deep%20red%20shirt%2C%20standing%20in%20front%20of%20a%20softly%20lit%20neutral%20wall%2C%20gentle%20natural%20lighting%2C%20warm%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail%2C%20professional%20magazine%20photography&width=400&height=400&seq=hl51-team-nanzhi&orientation=squarish",
  },
];